const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    // 要素が画面に入ったら
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
    }
  });
}, {
  threshold: 0.2 // 20% ほど見えたら実行
});

// .fade-in クラスがついたすべての要素を監視対象にする
document.querySelectorAll('.fade-in, .roll-item, .roll-item2').forEach(el => observer.observe(el));